// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Sidebarmenu_wrapper__7VLf3","active":"Sidebarmenu_active__qBYoG","iconMenu":"Sidebarmenu_iconMenu__3nn8G","textMenu":"Sidebarmenu_textMenu__3GR1T"};